import { Divider, Tabs } from "antd";
import React, { useEffect } from "react";
import AssessmentTab from "./AssessmentTab";
import AttemptAssessmentTab from "./AttemptAssessmentTab";
import { getAssessmentResultData } from "../slices/courseraSlice";
import { useDispatch, useSelector } from "react-redux";
import ProgressChart from "../Components/Charts/ProgressChart";

function MainAssessmentTab({ ids, AttemptedData }) {
  const dispatch = useDispatch();
  const userBasicInfo = useSelector((state) => state.user.userBasicInfo);
  const assessmentData = useSelector((state) => state.coursera.assessmentData);

  useEffect(() => {
    dispatch(getAssessmentResultData(userBasicInfo?.Email));
  }, []);

  return (
    <div>
      <div className="assessment-background mt-8 flex gap-4 mb-10 items-end pb-10 pr-32 justify-end">
        <Divider className="bg-pureWhite h-[75px] w-[2px]" type="vertical" />
        <div className="text-left">
          <h1 className="text-pureWhite text-[36px] font-bizmo font-semibold">
            Know Yourself
          </h1>
          <p className="text-pureWhite w-[350px] text-sm ">
            Developmental assessments are essential for personal and
            professional success. These assessments give feedback for focused
            development programs to improve skills, performance, and growth.
          </p>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <p className="font-semibold w-[400px]">
          We selected these assessments for your career development, education,
          and professional training programs to maximize your potential and
          ensure long-term success.
        </p>
        <div>
          <ProgressChart
            totalPercentage={
              (AttemptedData ? AttemptedData.length : 0 / assessmentData.length) * 100
            }
            height={100}
            width={200}
          />
        </div>
      </div>
      {/* <AssessmentTab /> */}
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane key="1" tab="All Assessment">
          <AssessmentTab ids={ids} />
        </Tabs.TabPane>
        <Tabs.TabPane key="2" tab="Attempt Assessment">
          <AttemptAssessmentTab AttemptedData={AttemptedData} />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default MainAssessmentTab;
